<template>
  <div>
    <div class="row mb-4 text-center">
      <div class="col-md-6 mx-auto">
        <h1 class="h4">Choose a plan</h1>
        <p class="lead mb-0">Superchargify comes with all inclusive plans!</p>
      </div>
    </div>
    <PlanSelector setup />
  </div>
</template>

<script>
import PlanSelector from '@/components/PlanSelector'

export default {
  components: {
    PlanSelector
  }
}
</script>
